/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ label: NonNullable<unknown> }} Tokens_NewInputs */

const en_tokens_new = /** @type {(inputs: Tokens_NewInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`New token “${i?.label}”`)
};

const de_tokens_new = /** @type {(inputs: Tokens_NewInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Neues Token „${i?.label}“`)
};

/**
* | output |
* | --- |
* | "New token “{label}”" |
*
* @param {Tokens_NewInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const tokens_new = /** @type {((inputs: Tokens_NewInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tokens_NewInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_tokens_new(inputs)
	return en_tokens_new(inputs)
});